// EmptyState — used across list/detail pages when there is nothing to show.
// Centred card with the brand "trajectory" illustration, title + subtitle,
// and an optional primary action button.
export default function EmptyState({
    title,
    subtitle,
    actionLabel,
    onAction,
    actionTestId,
    image = "/empty-trajectory.png",
    testId = "empty-state",
    className = "",
}) {
    return (
        <div
            data-testid={testId}
            className={
                "flex flex-col items-center justify-center text-center px-6 py-12 " +
                "bg-[var(--ux-bg-1)] border border-[var(--ux-border-1)] rounded-md " +
                className
            }
        >
            {image && (
                <img
                    src={image}
                    alt=""
                    aria-hidden="true"
                    width={160}
                    height={160}
                    className="opacity-70 select-none"
                    draggable="false"
                    style={{ width: 160, height: 160, objectFit: "contain" }}
                />
            )}
            {title && (
                <div className="mt-4 text-[16px] font-semibold text-[var(--ux-text-1)]">
                    {title}
                </div>
            )}
            {subtitle && (
                <div className="mt-1 text-[13px] text-[var(--ux-text-3)] max-w-md leading-relaxed">
                    {subtitle}
                </div>
            )}
            {actionLabel && onAction && (
                <button
                    type="button"
                    onClick={onAction}
                    data-testid={actionTestId || `${testId}-action`}
                    className="mt-5 inline-flex items-center gap-2 px-4 h-9 rounded-md bg-[var(--ux-accent)] text-[var(--ux-bg-0)] text-[13px] font-medium hover:opacity-90 transition-opacity"
                >
                    {actionLabel}
                </button>
            )}
        </div>
    );
}
